<div class="d-flex align-items-end flex-wrap gap-3 mb-3">
  <div class="form-group mb-0">
    <label for="tenant-settings-brand-primary-color" class="form-control-label" i18n="@@components.tenant_settings.brand_theme.primary_color">Primary Color</label><br>
    <input
      type="color"
      autocomplete="off"
      [ngModel]="brandThemeSettings.primaryColor"
      (ngModelChange)="setPrimaryColor($event)">
  </div>
  <div class="form-group mb-0">
    <label for="tenant-settings-brand-secondary-color" class="form-control-label" i18n="@@components.tenant_settings.brand_theme.secondary_color">Secondary Color</label><br>
    <input
      id="tenant-settings-brand-primary-color"
      type="color"
      autocomplete="off"
      [ngModel]="brandThemeSettings.secondaryColor"
      (ngModelChange)="setSecondaryColor($event)">
  </div>
</div>

<div class="d-flex align-items-start flex-wrap gap-3 mb-3">
  <app-logo-upload-resize></app-logo-upload-resize>
  @if (brandThemeSettings && brandThemeSettings.logoUrl) {
    <div style="background-color: #dbdcdc; overflow: hidden; border: 1px solid grey; height: 52px; width: 122px;">
      <img [src]="brandThemeSettings.logoUrl" width="120px" crossorigin="anonymous">
    </div>
  }
</div>

<div class="pt-3">
  <button class="btn btn-sm btn-danger btn-primary" (click)="resetBrandTheme()" i18n="@@components.tenant_settings.brand_theme.reset_btn">Reset Theme</button>
</div>
